import type { DeepQueryParams, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { useApi } from '@gik/core/api/swr/useApi';
import type { Group } from '@gik/core/models/gik/Group';
import type { GroupMember } from '@gik/core/models/gik/GroupMember';

export function useGroup(groupIdOrSlug?: string, config?: SWRConfigInterface) {
  return useApi<Group>(groupIdOrSlug ? `groups/${groupIdOrSlug}` : null, null, config);
}

export function useGroupMembers(groupIdOrSlug: string, search?: DeepQueryParams, config?: SWRConfigInterface) {
  return useApi<GroupMember[]>(groupIdOrSlug ? `groups/${groupIdOrSlug}/members` : null, search, config);
}
